import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nested-sidebar-introcwdm-dwdm-optnet-poster',
  templateUrl: '../../templates/Template-nested-sidebar-lead.html',
  styleUrls: ['./nested-sidebar-introcwdm-dwdm-optnet-poster.component.scss']
})
export class NestedSidebarIntrocwdmDwdmOptnetPosterComponent implements OnInit {

  constructor() { }

  pdf = {
    pdfTitle: 'Introduction to CWDM/DWDM<br>Optical Networks Poster',
    pdfimg: './assets/images/sidebar/Poster_DWDM_D99-00-016P_A00.webp',
    url: 'cwdmdwdmposter',
    opt: 'BUTTON.DOWNLOADREQ',
    width: '7200',
    height: '4800'
  };

  ngOnInit() {
  }

}
